import { Box } from '@mui/material';
import InfiniteScroll from 'react-swr-infinite-scroll';

import { CourseApiInfiniteResponse } from 'src/api/types/courseType';
import { LoadingInfiniteScroll } from 'src/components/atoms/loading';
import CoursesCard from 'src/components/molecules/courseCard';
import { isReachingEndOfCoursePages } from 'src/helpers/courseApiResponse';
import { useWindowSize } from 'src/helpers/use';
import { ICategory, ICoursesPagination } from 'src/interfaces';

type Props = {
  courseApiResponse: CourseApiInfiniteResponse;
  learningPathId?: number;
  learningPathCategory?: ICategory;
  courseCount?: number;
};

const CourseList = ({ courseApiResponse, learningPathId, learningPathCategory, courseCount }: Props) => {
  const { width } = useWindowSize();

  return (
    <InfiniteScroll
      swr={courseApiResponse}
      loadingIndicator={<LoadingInfiniteScroll />}
      isReachingEnd={isReachingEndOfCoursePages}
    >
      {(response: { data: ICoursesPagination }) => (
        <Box sx={{ mt: width! < 1150 ? 2 : 0 }}>
          <CoursesCard
            courses={response?.data?.items || []}
            learningPathId={learningPathId}
            learningPathCategory={learningPathCategory}
            courseCount={courseCount}
          />
        </Box>
      )}
    </InfiniteScroll>
  );
};

export default CourseList;
